
import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import {TranslateResult} from "vue-i18n";

@Component({})
export default class RelayAddReferents extends Vue {

    @Prop({default: null})
    public referents: any;

    @Prop({default: null})
    public relayId: number;

    @Prop({default: null})
    public companyId: number;
    public searchTimeout: any = null;

    @Getter private currentUser: any;
    @Getter private canDoInEnvCompany: (right: string) => boolean;

  private subordinates: any = [];
    private search: string = null;
    private newReferents: any = [];

    public async mounted() {
        this.newReferents = await JSON.parse(JSON.stringify(this.referents));
    }

    @Watch("search")
    @Watch("companyId", { immediate: true })
    public handlerSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
          this.getCompanyUsers();
      }, 500);
    }

    @Watch("newReferents")
    public handlerNewReferents() {
        this.$emit("update:referents", this.newReferents);
    }

    private getCompanyUsers(): void {
        const p: Array<Promise<any>> = [];
        if (this.canDoInEnvCompany("READ_CONTACTS")) {
          p.push(
            this.$store.dispatch("companies/getContacts", {
              id: this.companyId,
              query: {
                page : 1,
                itemsPerPage : 10,
                search: this.search,
                groups: true,
              },
            }),
          );
        }
        if (this.canDoInEnvCompany("READ_SUBORDINATES")) {
            p.push(
                this.$store.dispatch("companies/getSubordinates", {
                    id: this.companyId,
                    query: {
                        page : 1,
                        itemsPerPage : 10,
                        search: this.search,
                        groups: true,
                    },
                }),
            );
        }
        if (!p.length) {
          return this.$store.commit("alerts/displayError", {
            msg: this.$t("alerts.error.cantFetchUsers"),
          });
        }
        Promise.all(p).then(([contacts, subordinates]) => {
            this.subordinates = [
                ...contacts?.users || [],
                ...subordinates?.users || [],
            ].map((item: any) => ({...item.Users[0]}));
            this.subordinates = this.subordinates.filter((s) => !!s && s.id !== this.currentUser.id);
        });
    }

    private disableDuplicates(completeList, duplicates) {
        if (!completeList || !duplicates) {
            return null;
        }
        return completeList.map(
            (item: any) => {
                return duplicates.map((elem: any) => elem?.id)?.includes(item?.id) ? {...item, disabled: true} : item;
            },
        );
    }

    private remove(item) {
        const index = this.newReferents.findIndex((i: any) => i?.id === item.id);
        if (index >= 0) {
            this.newReferents.splice(index, 1);
        }
    }
}
